<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <!-- Refresh Button -->

            <v-btn
              v-if="$moduleAccess('abstract_endofday')"
              color="blue"
              small
              dark
              flat
              @click="openAbstactReport"
            >
              <v-icon>cached</v-icon>&nbsp; Generate Daily Abstract
            </v-btn>

            <refresh-button @refresh="refreshTable()"></refresh-button>
            <!-- <add-button @add="openAddDialog"></add-button> -->
            <!-- Dialog for Add, View Edit  -->
            <customize-dialog
              :type="dialogType"
              title="Daily Abstact Report"
              action="Generate"
              color="blue"
              :dialog="dialogStatusAbstract"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
              showSave
            >
              <v-container fluid grid-list-xs>
                <v-layout justify-center>
                  <v-flex md12>
                    <abstract-container
                      ref="abstractRef"
                      :data="abstractData"
                      :remittances="abstractRemittance"
                      :total="abstractTotal"
                      :remittanceDate="openDate"
                      :headers="abstractHeaders"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </customize-dialog>

            <trip-summary-dialog
              :type="dialogType"
              :title="'Trip Operation Report'"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container fluid grid-list-xs>
                <v-layout justify-center>
                  <v-flex md12>
                    <details-container
                      ref="detailsRef"
                      :data="viewData"
                      :eodDate="openDate"
                      :setting="$store.state.subcompany"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </trip-summary-dialog>

            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
                dialogType === 'abstract' ? saveAbstract() : saveTripSummary()
              "
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>
          </v-card-title>
          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <!-- <v-btn flat @click="openFilterExpansion">
                  <v-icon
                    class="mr-3"
                  >{{ openFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>-->
              </v-flex>

              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            Row per Page:
                          </p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter">
            <v-flex md4 v-if="$store.state.companies.length">
              <v-select
                v-model="filterCompany"
                :items="filterCompanies"
                label="By Company"
                solo
                clearable
              ></v-select>
            </v-flex>
            <v-flex md4 v-if="$store.state.sub_companies.length">
              <v-select
                v-model="filterSubCompany"
                :items="filterSubCompanies"
                label="By Sub-Company"
                solo
                clearable
              ></v-select>
            </v-flex>
          </filter-panel>

          <v-data-table
            :headers="
              $store.state.subcompany
                ? $store.state.company.code === 'DLTB'
                  ? DLTBHeaders
                  : headers
                : headers
            "
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                >
                  {{ header.text.toUpperCase() }}
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.index + queryParams.offset + 1 }}
              </td>
              <td class="text-xs-left">{{ props.item.control_no }}</td>
              <td class="text-xs-left text-uppercase">
                {{ props.item.vehicle_no }}
              </td>
              <td class="text-xs-left">
                {{ $dateFormat(props.item.created_at, "YYYY-MM-DD") }}
              </td>
              <td class="text-xs-left">
                {{ $dateFormat(props.item.created_at, "HH:mm") }}
              </td>
              <td class="text-no-wrap text-xs-center">
                <v-tooltip top>
                  <v-btn
                    v-if="$moduleAccess('trip_endofday')"
                    icon
                    slot="activator"
                    @click="openViewDialog(props.item)"
                  >
                    <v-icon color="blue">update</v-icon>
                  </v-btn>
                  <span>Trip</span>
                </v-tooltip>
                <!-- <edit-button @edit="openEditDialog(props.item)"></edit-button> -->
                <!-- <delete-button @delete="openDeleteDialog(props.item)"></delete-button> -->
                <!-- <assign-button title="Assign to Project" @assign="openSubscribeDialog(props.item)"></assign-button> -->
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";
import DetailsContainer from "@/components/TripOperationReport";
import AbstractContainer from "@/components/DailyAbstractReport";
import TripSummaryDialog from "@/components/dialog/TripReportDialog";
import JsPdf from "jspdf";
import "jspdf-autotable";

export default {
  components: {
    DetailsContainer,
    AbstractContainer,
    TripSummaryDialog,
  },
  data() {
    return {
      openFilter: false,
      filterCompanies: [],
      filterCompany: null,
      filterSubCompanies: [],
      filterSubCompany: null,

      title: "End Of Day",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Control No.",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "STORE NAME",
          align: "left",
          value: "vehicle_no",
          sortable: false,
        },
        {
          text: "Date",
          align: "left",
          value: "date",
          sortable: false,
        },
        {
          text: "Time",
          align: "left",
          value: "date",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],
      dltbHeaders: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "TOR No.",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "STORE NAME",
          align: "left",
          value: "vehicle_no",
          sortable: false,
        },
        {
          text: "Date",
          align: "left",
          value: "date",
          sortable: false,
        },
        {
          text: "Time",
          align: "left",
          value: "date",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],
      abstractHeaders: [
        {
          text: "OR No.",
          align: "center",
          value: "or_no",
          sortable: false,
        },
        {
          text: "STORE NAME",
          align: "center",
          value: "vehicle_no",
          sortable: false,
        },
        {
          text: "Trip Date",
          align: "center",
          value: "vehicle_no",
          sortable: false,
        },
        {
          text: "No. of Trips",
          align: "center",
          value: "no_of_trips",
          sortable: false,
        },
        {
          text: "KM Run",
          align: "center",
          value: "km_run",
          sortable: false,
        },
        {
          text: "Driver",
          align: "center",
          value: "driver_id",
          sortable: false,
        },
        {
          text: "Conductor",
          align: "center",
          value: "conductor_id",
          sortable: false,
        },
        {
          text: "Gross Income",
          align: "center",
          value: "gross_collection",
          sortable: false,
        },
        {
          text: "Partial & Special",
          align: "center",
          value: "partial_special",
          sortable: false,
        },
        {
          text: "DriCon Comm.",
          align: "center",
          value: "dricon_commission",
          sortable: false,
        },
        {
          text: "Toll & Road",
          align: "center",
          value: "toll_road",
          sortable: false,
        },
        {
          text: "DriCon Adv.",
          align: "center",
          value: "dricon_advances",
          sortable: false,
        },
        {
          text: "Net Cash",
          align: "center",
          value: "net_cash",
          sortable: false,
        },
        {
          text: "Short / Over",
          align: "center",
          value: "short_over",
          sortable: false,
        },
      ],
      employeeHeaders: [
        {
          text: "Employee Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Card Position",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Web Position",
          align: "left",
          value: "name",
          sortable: false,
        },
      ],
      items: [],
      data: {},
      employeeItems: [],
      queryParams: {
        search: "",
        limit: 10,
        offset: 0,
        company_id: null,
        sub_company_id: null,
      },
      dialogType: "",
      dialogStatus: false,
      dialogStatusAbstract: false,
      openConfirmDialog: false,
      viewData: {},
      viewUser: {},
      abstractData: {},
      abstractRemittance: [],
      abstractTotal: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
      ],
      selected: [],
      addDialog: false,

      subscribeDialog: false,
      assignItems: [],
      positions: [
        {
          text: "ADMIN",
          value: "admin",
        },
        {
          text: "CASHIER",
          value: "cashier",
        },
        {
          text: "CONDUCTOR",
          value: "conductor",
        },
        {
          text: "DISPATCHER",
          value: "dispatcher",
        },
        {
          text: "DRIVER",
          value: "driver",
        },
        {
          text: "INSPECTOR",
          value: "inspector",
        },
        {
          text: "GAS MAN",
          value: "gas man",
        },
        {
          text: "SUPERVISOR",
          value: "supervisor",
        },
      ],
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
      subcompanies: [],
      accessCards: [],
      openDate: null,
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
  },
  watch: {
    filterCompany: async function() {
      if (
        this.filterCompany !== null &&
        this.filterCompany !== undefined &&
        this.filterCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.company_id = this.filterCompany;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.company_id = null;
        this.getData();
      }
    },
    filterSubCompany: async function() {
      if (
        this.filterSubCompany !== null &&
        this.filterSubCompany !== undefined &&
        this.filterSubCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = this.filterSubCompany;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = null;
        this.getData();
      }
    },
  },
  methods: {
    search(data) {
      console.log(data);
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");

      this.queryParams.company_id = this.$store.state.company.id;
      this.queryParams.sub_company_id = this.$store.state.subcompany.id;

      try {
        // Query Data
        let response = (await Services.getEndOfDay(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async getProjects() {
      // Start Loading
      this.assignItems = [];
      const response = this.$store.state.subcompany;

      this.assignItems = response.projects;
    },
    async setData(id) {
      const data = {};

      try {
        let params = {
          company_code: null,
          coding_param: null,
          remittance_sync_id: id,
          sub_company_id: this.$store.state.subcompany.id,
          gross_collection: null,
          gross_revenue: null,
          total_expense: null,
          total_partial: null,
          presell_sales: null,
          card_sales: null,
          total_cash_advance: null,
          cash_received: null,
        };

        const response1 = await Services.getEndOfDayTripSummaryHeader(params);
        // params.sub_company_id = await response1.data.sub_company_id;
        params.company_code = await response1.data.company_code;
        params.gross_collection = (await response1.data.gross_collection)
          ? response1.data.gross_collection
          : 0;
        params.gross_revenue = (await response1.data.gross_revenue)
          ? response1.data.gross_revenue
          : 0;
        data.header = await response1.data;

        const response3 = await Services.getEndOfDayTripSummaryTicketIssuance(
          params
        );
        data.tick_issuance = response3.data;

        if (
          response1.ticketing_type != null ||
          response1.ticketing_type != undefined ||
          response1.ticketing_type != ""
        ) {
          if (response1.ticketing_type != 2) {
            const response2 = await Services.getEndOfDayTripSummaryTripRecord(
              params
            );
            data.trip_record = response2.data;

            const response4 = await Services.getEndOfDayTripSummaryInpections(
              params
            );
            data.inspections = response4.data;

            const response5 = await Services.getEndOfDayTripSummaryCashDeposit(
              params
            );
            data.cash_deposit = response5.data;

            const response6 = await Services.getEndOfDayTripSummaryCashAdvance(
              params
            );
            data.cash_advances = response6.data;

            const response7 = await Services.getEndOfDayTripSummaryFuel(params);
            data.diesels = response7.data;

            const response8 = await Services.getEndOfDayTripSummaryExpenses(
              params
            );
            data.expenses = response8.data;

            if (params.company_code == "DLTB") {
              params.total_expense = (await response1.data.total_expense)
                ? response1.data.total_expense
                : 0;
              params.total_partial = (await response1.data.total_partial)
                ? response1.data.total_partial
                : 0;
              params.presell_sales = (await response3.data.presell_sales)
                ? response3.data.presell_sales
                : 0;
              params.card_sales = (await response3.data.card_sales)
                ? response3.data.card_sales
                : 0;
              params.total_cash_advance = (await response6.data
                .total_cash_advance)
                ? response6.data.total_cash_advance
                : 0;
              params.cash_received = (await response1.data.cash_received)
                ? response1.data.cash_received
                : 0;
              const response9 = await Services.getEndOfDayTripSummarySpecialContents(
                params
              );
              data.sp_contents = response9.data;
              if (
                response1.status != 200 &&
                response2.status != 200 &&
                response3.status != 200 &&
                response4.status != 200 &&
                response5.status != 200 &&
                response6.status != 200 &&
                response7.status != 200 &&
                response8.status != 200 &&
                response9.status != 200
              ) {
                this.$infoBar({
                  type: "error",
                  text: "No network or server connection",
                });
                return;
              }
            }
            if (
              response1.status != 200 &&
              response2.status != 200 &&
              response3.status != 200 &&
              response4.status != 200 &&
              response5.status != 200 &&
              response6.status != 200 &&
              response7.status != 200 &&
              response8.status != 200
            ) {
              this.$infoBar({
                type: "error",
                text: "No network or server connection",
              });
              return;
            }
          } else if (response1.ticketing_type == 2) {
            if (response1.status != 200 && response3.status != 200) {
              this.$infoBar({
                type: "error",
                text: "No network or server connection",
              });
              return;
            }
          }
        } else {
          this.$infoBar({
            type: "error",
            text: "ticketing_type not found",
          });
          return;
        }
      } catch (error) {
        // if (!error.response) {
        this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
        // }
        return;
      }
      return data;
    },
    async setUser(id) {
      var data = {};

      try {
        const response = await Services.getUser(id);
        data = await response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      return data;
    },
    async setEmployees() {
      this.employeeItems = [];
      this.employeeItems = (
        await Services.getUnassignedEmployees({
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
          project_id: this.$store.state.project.id,
        })
      ).data;
    },
    async setAccessCards() {
      this.accessCards = [];

      const response = await Services.getAccessCard(
        this.viewData.access_card_id
      );
      const data = await response.data;

      this.accessCards.push({
        text: data.embedded_id.toUpperCase(),
        value: data.id,
      });
    },
    async setSubCompanies() {
      this.subcompanies = [];
      const response = await Services.getSubCompany(
        this.viewData.employed_sub_company_id
      );
      const data = await response.data;

      this.subcompanies.push({
        text: data.name.toUpperCase(),
        value: data.id,
      });
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.addDialog = true;

      this.setEmployees();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.viewData = {};

      this.data.id = data.id;

      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);

      this.openDate = this.$dateFormat(new Date(), "MM/DD/YYYY hh:mm:ss A");

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openAbstactReport() {
      this.dialogLoading = true;

      this.openDate = this.$dateFormat(null, "MM/DD/YYYY hh:mm:ss A");

      var data = {};

      try {
        const response = (
          await Services.getEndOfDayAbstract({
            company_id: this.$store.state.company.id,
            sub_company_id: this.$store.state.subcompany.id,
          })
        ).data;

        if (!response.data.remittances.length) {
          this.$infoBar({
            type: "error",
            text: "No data found",
          });

          return;
        }

        this.abstractData = response.data;
        this.abstractRemittance = response.data.remittances;
        this.abstractTotal = response.data.total;

        this.dialogType = "abstract";
        this.dialogStatusAbstract = true;

        console.log(this.abstractData);
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },

    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "edit";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);
      // let test = JSON.parse(this.viewData.phone_no);
      // console.log(test);
      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.viewData.id = data.id;
    },
    saveDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveTripSummary() {
      this.confirmLoading = true;

      await this.downloadPDF();

      try {
        const response = await Services.closeEndOfDay(this.data.id);

        this.closeConfirmDialog();
        this.closeDialog();
        await this.getData();
        this.$infoBar({
          type: "success",
          text: "EOD has been saved!",
        });
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },
    async saveAbstract() {
      // this.confirmLoading = true;

      const data = this.$refs.abstractRef.computedData;

      const body = data.map((item) => {
        return {
          id: item.id,
        };
      });

      try {
        const response = await Services.generateAbstract({
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
          date: this.openDate,
          remittances: body,
        });

        // Download PDF

        await this.downloadAbstractPDF(data);

        this.closeConfirmDialog();
        this.closeDialog();
        await this.getData();
        this.$infoBar({
          type: "success",
          text: "Abstact has been saved!",
        });
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      // this.confirmLoading = false;
    },
    numberWithCommas(numC) {
      if (numC === undefined || numC === "") {
        return "";
      }
      numC = parseFloat(numC).toFixed(2);
      return numC.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async downloadPDF() {
      const doc = new JsPdf("l", "pt", "letter");

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text(this.viewData.header.sub_company.toUpperCase(), 390, 30, {
        align: "center",
      });
      doc.text("TRIP OPERATION REPORT", 385, 45, { align: "center" });

      if (this.viewData.header.ticketing_type == 2) {
        let width = 780 / 4;

        doc.setFillColor(255, 255, 255);
        doc.setLineWidth(2);

        doc.rect(10, 65, width, 30, "DF");
        doc.rect(width, 65, width, 30, "DF");
        doc.rect(width * 2, 65, width, 30, "DF");
        doc.rect(width * 3, 65, width, 30, "DF");

        doc.rect(10, 95, width, 30, "DF");
        doc.rect(width, 95, width, 30, "DF");
        doc.rect(width * 2, 95, width, 30, "DF");
        doc.rect(width * 3, 95, width, 30, "DF");

        doc.rect(10, 125, width, 30, "DF");
        doc.rect(width, 125, width, 30, "DF");
        doc.rect(width * 2, 125, width, 30, "DF");
        doc.rect(width * 3, 125, width, 30, "DF");

        doc.rect(10, 155, width, 30, "DF");
        doc.rect(width, 155, width, 30, "DF");
        doc.rect(width * 2, 155, width, 30, "DF");
        doc.rect(width * 3, 155, width, 30, "DF");

        doc.rect(10, 185, 390, 30, "DF");
        doc.rect(390, 185, 390, 30, "DF");

        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text("EMPLOYEE NO.", (width - 10) / 2, 82, { align: "center" });
        doc.text("TELLER", (width - 10) / 2, 112, { align: "center" });
        doc.text("TERMINAL", (width - 10) / 2, 142, { align: "center" });
        doc.text("CONTROL NO. ", (width - 10) / 2, 172, { align: "center" });

        doc.text("DATE AND TIME TRIP", (width - 10) / 2 + width * 2, 82, {
          align: "center",
        });
        doc.text("DATE AND TIME REMIT", (width - 10) / 2 + width * 2, 112, {
          align: "center",
        });
        doc.text("DATE AND TIME OF EOD", (width - 10) / 2 + width * 2, 142, {
          align: "center",
        });
        doc.text("DEVICE SERIAL", (width - 10) / 2 + width * 2, 172, {
          align: "center",
        });

        doc.setFontType("normal");
        doc.text(
          this.viewData.header.cashier_no
            ? this.viewData.header.cashier_no.toUpperCase()
            : "-",
          (width - 10) / 2 + width,
          82,
          { align: "center" }
        );
        doc.text(
          this.viewData.header.cashier_name
            ? this.viewData.header.cashier_name.toUpperCase()
            : "-",
          (width - 10) / 2 + width,
          112,
          {
            align: "center",
          }
        );
        doc.text(
          this.viewData.header.terminal_name
            ? this.viewData.header.terminal_name.toUpperCase()
            : "",
          (width - 10) / 2 + width,
          142,
          {
            align: "center",
          }
        );
        doc.text(
          this.viewData.header.control_no
            ? this.viewData.header.control_no
            : "-",
          (width - 10) / 2 + width,
          172,
          {
            align: "center",
          }
        );
        doc.text(
          this.viewData.header.trip_date
            ? this.$dateFormat(
                this.viewData.header.trip_date,
                "MM/DD/YYYY hh:mm:ss A"
              )
            : "-",
          (width - 10) / 2 + width * 3,
          82,
          {
            align: "center",
          }
        );
        doc.text(
          this.viewData.header.remittance_date
            ? this.$dateFormat(
                this.viewData.header.remittance_date,
                "MM/DD/YYYY hh:mm:ss A"
              )
            : "-",
          (width - 10) / 2 + width * 3,
          112,
          {
            align: "center",
          }
        );
        doc.text(
          this.openDate ? this.openDate : "",
          (width - 10) / 2 + width * 3,
          142,
          {
            align: "center",
          }
        );
        doc.text(
          this.viewData.header.device_serial
            ? this.viewData.header.device_serial
            : "-",
          (width - 10) / 2 + width * 3,
          172,
          {
            align: "center",
          }
        );

        doc.setFontType("bold");
        //last table row
        doc.text(
          this.viewData.tick_issuance.card_sales
            ? `CARD SALES: P ${this.numberWithCommas(
                this.viewData.tick_issuance.card_sales
              )}`
            : "-",
          195,
          202,
          {
            align: "center",
          }
        );
        doc.text(
          this.viewData.header.gross_collection
            ? `GROSS REVENUE: P ${this.numberWithCommas(
                this.viewData.header.gross_collection
              )}`
            : "-",
          585,
          202,
          {
            align: "center",
          }
        );

        // Here is the Data of TICKET ISSUANCE

        const headers = [["Route", "Transaction Count", "Gross Revenue"]];
        // this.viewData.tick_issuance.passenger_type_header.forEach((item) => {
        //   headers[0].push(item.name ? item.name.toUpperCase() : "");
        // });

        const data = [];

        let ticketIssuancePassengerTypeCount = 0;

        if (this.viewData.tick_issuance.ticket_issuance) {
          this.viewData.tick_issuance.ticket_issuance.forEach((item) => {
            let theData = [
              item.route_name ? item.route_name.toUpperCase() : "-",
              item.passenger_count,
              "P" + " " + this.numberWithCommas(item.gross_revenue),
            ];
            item.passenger_type_data.forEach((item) => {
              theData.push(item.count);
            });

            ticketIssuancePassengerTypeCount = item.passenger_type_data.length;

            data.push(theData);
          });
        }

        const footer = [
          [
            "TOTAL:",
            this.viewData.tick_issuance.ticket_issuance_total.passenger_count,
            "P" +
              " " +
              this.numberWithCommas(
                this.viewData.tick_issuance.ticket_issuance_total.gross_revenue
              ),
          ],
        ];

        // this.viewData.tick_issuance.passenger_type_header.forEach((item) => {
        //   footer[0].push(item.total_count);
        // });

        doc.autoTable({
          didParseCell: (data) => {
            const col = data.column.index;
            if (
              col === 2 ||
              col === "2" ||
              col === 3 ||
              col === "3" ||
              col === 4 ||
              col === "4" ||
              col === 5 ||
              col === "5" ||
              col === 6 ||
              col === "6" ||
              col === 7 ||
              col === "7" ||
              col === 8 ||
              col === "8"
            ) {
              data.table.styles.headStyles.halign = "right";
            } else {
              data.table.styles.headStyles.halign = "left";
            }
            data.table.foot[0].cells[2].styles.halign = "left";
          },

          head: headers,
          body: data,
          foot: footer,
          startY: 260,
          margin: {
            left: 10,
          },
          theme: "grid",
          tableWidth: ticketIssuancePassengerTypeCount > 5 ? "auto" : 770,
          cellWidth: "wrap",
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
          },
          footStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            halign: "right",
          },
          tableLineColor: 200,
          tableLineWidth: 0,
          columnStyles: {
            0: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
            },
            1: { cellWidth: "auto", lineColor: "black", textColor: [0, 0, 0] },
            2: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
            },
            3: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            4: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            5: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            6: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            7: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            8: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            9: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
          },
          styles: {
            overflow: "linebreak",
            cellWidth: "wrap",
            lineColor: "black",
            textColor: [0, 0, 0],
            fontSize: 10,
            lineWidth: 2,
          },
        });

        // Here is the Boxes of TICKET ISSUANCE

        doc.setFillColor(224, 224, 224);
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(2);
        doc.rect(10, 230, 770, 30, "DF");

        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text("TICKET ISSUANCE", 405, 250, { align: "center" });
      } else if (this.viewData.header.ticketing_type != 2) {
        // Here is the Boxes of EMP. NO., DRIVER, DATE AND TERMINAL: (FIRST DISPATCH)

        doc.setFillColor(255, 255, 255);
        doc.setLineWidth(2);
        doc.rect(10, 65, 320, 30, "DF");
        doc.rect(80, 65, 320, 30, "DF");
        // doc.rect(270, 65, 70, 30, "DF");
        // doc.rect(340, 65, 190, 30, "DF");
        doc.rect(400, 65, 260, 30, "DF");
        doc.rect(520, 65, 260, 30, "DF");

        // Here is the Data of EMP. NO., DRIVER, DATE AND TERMINAL: (FIRST DISPATCH)

        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text("EMP. NO.", 45, 82, { align: "center" });
        // doc.text("DRIVER", 305, 82, { align: "center" });
        doc.text("TERMINAL", 455, 82, { align: "center" });
        doc.setFontType("normal");
        doc.text(
          this.viewData.header.driver_no
            ? this.viewData.header.driver_no.toUpperCase()
            : "-",
          85,
          82,
          { align: "left" }
        );
        // doc.text(
        //   this.viewData.header.driver_name
        //     ? this.viewData.header.driver_name.toUpperCase()
        //     : "-",
        //   345,
        //   82,
        //   { align: "left" }
        // );
          doc.text(
          this.viewData.header.terminal_name
          ? this.viewData.header.terminal_name.toUpperCase()
          : "-",
          530,
          82,
          { align: "left" }
        );

        // Here is the Boxes of EMP NO., CONDUCTOR and CONTROL NUMBER: (CLOSE TRIP)

        doc.setFillColor(255, 255, 255);
        doc.setLineWidth(2);
        doc.rect(10, 95, 320, 30, "DF");
        doc.rect(80, 95, 320, 30, "DF");
        // doc.rect(270, 95, 70, 30, "DF");
        // doc.rect(340, 95, 190, 30, "DF");
        doc.rect(400, 95, 260, 30, "DF");
        doc.rect(520, 95, 260, 30, "DF");

        // Here is the Data of EMP NO., CONDUCTOR and CONTROL NUMBER: (CLOSE TRIP)

        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text("EMP. NO.", 45, 113, { align: "center" });
        // doc.text("CONDUCTOR", 305, 113, { align: "center" });
        // doc.text("DATE & TIME OF REMIT", 460, 113, { align: "center" });
        doc.setFontType("normal");
        doc.text(
          this.viewData.header.conductor_no
            ? this.viewData.header.conductor_no.toUpperCase()
            : "-",
          85,
          113,
          { align: "left" }
        );
        // doc.text(
        //   this.viewData.header.conductor_name
        //     ? this.viewData.header.conductor_name.toUpperCase()
        //     : "-",
        //   345,
        //   113,
        //   { align: "left" }
        // );
        doc.setFontType("bold");
          doc.text(
          this.$store.state.company.code === "DLTB"
          ? "TOR NO. :"
          : "CONTROL NO. :",
          460,
          113,
          { align: "center" }
          );
          doc.setFontType("normal");
          doc.text(
          this.viewData.header.control_no
          ? this.viewData.header.control_no
          : "-",
          530,
          113,
          {
            align: "left",
          }
        );
    
        // Boxes for VEHICLE NO., TERMINAL, and Device Serial

        doc.setFillColor(255, 255, 255);
        doc.setLineWidth(2);
        doc.rect(10, 125, 320, 30, "DF");
        doc.rect(80, 125, 320, 30, "DF");
        // doc.rect(270, 125, 70, 30, "DF");
        // doc.rect(340, 125, 190, 30, "DF");
        doc.rect(400, 125, 260, 30, "DF");
        doc.rect(520, 125, 260, 30, "DF");

        // Here is the Data of VEHICLE NO., TERMINAL, and Device Serial

        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text("STORE NAME", 45, 143, { align: "center" });
        // doc.text("TERMINAL", 305, 143, { align: "center" });
        doc.text("DEVICE SERIAL:", 460, 143, { align: "center" });
        doc.setFontType("normal");
        doc.text(
          this.viewData.header.vehicle_no
            ? this.viewData.header.vehicle_no.toUpperCase()
            : "-",
          85,
          143,
          { align: "left" }
        );
        // doc.text(
        //   this.viewData.header.terminal_name
        //     ? this.viewData.header.terminal_name.toUpperCase()
        //     : "-",
        //   345,
        //   143,
        //   { align: "left" }
        // );
        doc.text(
          this.viewData.header.device_serial
          ? this.viewData.header.device_serial
          : "-",
          530,
          143,
          { align: "left" }
        );

        // Here is the Boxes of Date and time of Trip, Date and Time of Remit, and Date and time of EOD
        doc.setFillColor(255, 255, 255);
        doc.setLineWidth(2);
        doc.rect(10, 155, 128.2, 30, "DF");
        doc.rect(138, 155, 128.2, 30, "DF");
        doc.rect(267, 155, 128.2, 30, "DF");
        doc.rect(396, 155, 128.2, 30, "DF");
        doc.rect(525, 155, 128.2, 30, "DF");
        doc.rect(653, 155, 128.2, 30, "DF");

        // Here is the Data of Date and time of Trip, Date and Time of Remit, and Date and time of EOD
        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text("DATE & TIME OF TRIP", 70, 172, { align: "center" });
        doc.text("DATE & TIME OF REMIT", 330, 172, { align: "center" });
        doc.text("DATE & TIME OF EOD", 590, 173, { align: "center" });
        doc.setFontType("normal");
        doc.setFontSize(9);
        doc.text(
          this.viewData.header.trip_date
            ? this.$dateFormat(
                this.viewData.header.trip_date,
                "MM/DD/YYYY hh:mm:ss A"
              )
            : "",
          200,
          172,
          { align: "center" }
        );
        doc.setFontSize(9);
        doc.text(
          this.viewData.header.remittance_date
            ? this.$dateFormat(
                this.viewData.header.remittance_date,
                "MM/DD/YYYY hh:mm:ss A"
              )
            : "",
          460,
          172,
          { align: "center" }
        );
        doc.setFontSize(9);
        doc.text(this.openDate ? this.openDate : "", 720, 172, {
          align: "center",
        });

        // Here is the DATA of CONTROL NUMBER and DEVICE SERIAL NUMBER

        // doc.setFontSize(10);
        // doc.setFontType("bold");
        // doc.text("TERMINAL", 45, 172, { align: "center" });
        // doc.text(
        //   this.viewData.header.terminal_name
        //     ? this.viewData.header.terminal_name.toUpperCase()
        //     : "-",
        //   130,
        //   172,
        //   { align: "left" }
        // );
        // doc.text(
        //   this.$store.state.company.code === "DLTB"
        //     ? "TOR NO. :"
        //     : "CONTROL NO. :",
        //   272,
        //   172,
        //   { align: "center" }
        // );
        // doc.text("DEVICE SERIAL:", 580, 172, { align: "center" });
        // doc.setFontType("normal");
        // doc.text(
        //   this.viewData.header.control_no
        //     ? this.viewData.header.control_no
        //     : "-",
        //   350,
        //   172,
        //   {
        //     align: "left",
        //   }
        // );
        // doc.text(
        //   this.viewData.header.device_serial
        //     ? this.viewData.header.device_serial
        //     : "-",
        //   594,
        //   172,
        //   { align: "left" }
        // );

        // Here is the Data of TICKET ISSUANCE

        const headers = [
          [
            "BRANCH",
            "Ticket No. Beginning",
            "Ticket No. Ending",
            "Transaction Count",
            "Gross Revenue"
          ],
        ];
        // this.viewData.tick_issuance.passenger_type_header.forEach((item) => {
        //   headers[0].push(item.name ? item.name.toUpperCase() : "");
        // });

        const data = [];

        let ticketIssuancePassengerTypeCount = 0;

        if (this.viewData.tick_issuance.ticket_issuance) {
          this.viewData.tick_issuance.ticket_issuance.forEach((item) => {
            let theData = [
              item.route_name ? item.route_name.toUpperCase() : "-",
              item.opening_ticket,
              item.closing_ticket,
              item.passenger_count,
              "P" + " " + this.numberWithCommas(item.gross_revenue),
            ];
            item.passenger_type_data.forEach((item) => {
              theData.push(item.count);
            });

            ticketIssuancePassengerTypeCount = item.passenger_type_data.length;

            data.push(theData);
          });
        }

        const footer = [
          [
            "",
            "",
            "TOTAL:",
            this.viewData.tick_issuance.ticket_issuance_total.passenger_count,
            "P" +
              " " +
              this.numberWithCommas(
                this.viewData.tick_issuance.ticket_issuance_total.gross_revenue
              ),
          ],
        ];

        // this.viewData.tick_issuance.passenger_type_header.forEach((item) => {
        //   footer[0].push(item.total_count);
        // });

        doc.autoTable({
          didParseCell: (data) => {
            const col = data.column.index;
            if (
              col === 2 ||
              col === "2" ||
              col === 3 ||
              col === "3" ||
              col === 4 ||
              col === "4" ||
              col === 5 ||
              col === "5" ||
              col === 6 ||
              col === "6" ||
              col === 7 ||
              col === "7" ||
              col === 8 ||
              col === "8"
            ) {
              data.table.styles.headStyles.halign = "right";
            } else {
              data.table.styles.headStyles.halign = "left";
            }
            data.table.foot[0].cells[2].styles.halign = "left";
          },

          head: headers,
          body: data,
          foot: footer,
          startY: 226,
          margin: {
            left: 10,
          },
          theme: "grid",
          tableWidth: ticketIssuancePassengerTypeCount > 5 ? "auto" : 770,
          cellWidth: "wrap",
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
          },
          footStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            halign: "right",
          },
          tableLineColor: 200,
          tableLineWidth: 0,
          columnStyles: {
            0: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
            },
            1: { cellWidth: "auto", lineColor: "black", textColor: [0, 0, 0] },
            2: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
            },
            3: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            4: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            5: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            6: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            7: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            8: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            9: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
          },
          styles: {
            overflow: "linebreak",
            cellWidth: "wrap",
            lineColor: "black",
            textColor: [0, 0, 0],
            fontSize: 10,
            lineWidth: 2,
          },
        });

        // Here is the Boxes of TICKET ISSUANCE

        doc.setFillColor(224, 224, 224);
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(2);
        doc.rect(10, 195, 770, 30, "DF");

        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text("TICKET ISSUANCE", 405, 213, { align: "center" });

        let finalY = doc.autoTable.previous.finalY;

        // Next Page...

        // doc.addPage();

        // Here is the Boxes of TRIP RECORD

        doc.setFillColor(224, 224, 224);
        doc.setLineWidth(2);
        doc.setDrawColor(0, 0, 0);
        doc.rect(10, finalY + 10, 770, 30, "DF");
        // doc.rect(10, 10, 770, 30, "DF");

        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text("TRIP RECORD", 405, finalY + 27, { align: "center" });
        // doc.text("TRIP RECORD", 405, 27, { align: "center" });

        // Here is the Boxes of Departed At and Arrived At

        doc.setFillColor(255, 255, 255);
        doc.setLineWidth(2);
        doc.setDrawColor(0, 0, 0);
        doc.rect(10, finalY + 40, 390, 30, "DF");
        doc.rect(400, finalY + 40, 380, 30, "DF");
        // doc.rect(10, 40, 390, 30, "DF");
        // doc.rect(400, 40, 380, 30, "DF");

        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text("DEPARTED AT", 200, finalY + 57, { align: "center" });
        doc.text("ARRIVED AT", 600, finalY + 57, { align: "center" });
        // doc.text("DEPARTED AT", 200, 57, { align: "center" });
        // doc.text("ARRIVED AT", 600, 57, { align: "center" });

        // Here is the Data of TRIP RECORD

        const headers_2 = [
          ["Date/Time", "Place", "Name", "Date/Time", "Place", "Name"],
        ];

        const data_2 = [];

        if (this.viewData.trip_record) {
          if (this.viewData.trip_record.trip_rec) {
            this.viewData.trip_record.trip_rec.forEach((item) => {
              let theData_2 = [
                this.$dateFormat(item.dispatched_date, "MM/DD/YYYY hh:mm:ss A"),
                item.dispatched_place
                  ? item.dispatched_place.toUpperCase()
                  : "-",
                item.dispatched_by ? item.dispatched_by.toUpperCase() : "-",
                this.$dateFormat(
                  item.arrival_datetime,
                  "MM/DD/YYYY hh:mm:ss A"
                ),
                item.arrival_place ? item.arrival_place.toUpperCase() : "-",
                item.arrival_by ? item.arrival_by.toUpperCase() : "-",
              ];
              data_2.push(theData_2);
            });
          }
        }

        doc.autoTable({
          didParseCell: (data) => {
            const col = data.column.index;
            if (
              col === 0 ||
              col === "0" ||
              col === 1 ||
              col === "1" ||
              col === 3 ||
              col === "3" ||
              col === 4 ||
              col === "4"
            ) {
              data.table.styles.headStyles.halign = "left";
            } else {
              data.table.styles.headStyles.halign = "center";
            }
          },
          head: headers_2,
          body: data_2,
          startY: finalY + 70,
          // startY: 70,
          margin: {
            left: 10,
          },
          theme: "grid",
          tableWidth: 770,
          cellWidth: "wrap",
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
          },
          tableLineColor: 200,
          tableLineWidth: 0,
          columnStyles: {
            0: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "center",
            },
            1: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "left",
            },
            2: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "left",
            },
            3: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "center",
            },
            4: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "left",
            },
            5: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "left",
            },
          },
          styles: {
            overflow: "linebreak",
            cellWidth: "wrap",
            fontSize: 10,
            lineWidth: 2,
            halign: "center",
          },
        });

        let finalY_2 = doc.autoTable.previous.finalY;

        // Next Page...

        // doc.addPage();
        // Here is the Boxes of INSPECTIONS

        // doc.setFillColor(224, 224, 224);
        // doc.setLineWidth(2);
        // doc.setDrawColor(0, 0, 0);
        // doc.rect(10, finalY_2 + 10, 770, 30, "DF");

        // doc.setFontSize(10);
        // doc.setFontType("bold");
        // doc.text("INSPECTIONS", 405, finalY_2 + 27, { align: "center" });

        // Here is the Data of INSPECTIONS

        // const headers_3 = [
        //   ["Date", "Time", "Km On", "Place", "Bound", "Headcount", "Name"],
        // ];

        // const data_3 = [];

        if (this.viewData.inspections) {
          this.viewData.inspections.forEach((item) => {
            let theData_3 = [
              item.date ? this.$dateFormat(item.date, "MM/DD/YYYY") : "-",
              item.date ? this.$dateFormat(item.date, "hh:mm:ss A") : "-",
              item.km_on == null ? "-" : item.km_on,
              item.place ? item.place.toUpperCase() : "-",
              item.bound ? item.bound.toUpperCase() : "-",
              item.head_count === null ? "-" : item.head_count,
              item.name ? item.name.toUpperCase() : "-",
            ];
            data_3.push(theData_3);
          });
        }

        // doc.autoTable({
        //   didParseCell: (data) => {
        //     const col = data.column.index;
        //     if (col === 2 || col === "2" || col === 5 || col === "5") {
        //       data.table.styles.headStyles.halign = "left";
        //     } else if (col === 1 || col === "1" || col === 4 || col === "4") {
        //       data.table.styles.headStyles.halign = "right";
        //     } else {
        //       data.table.styles.headStyles.halign = "center";
        //     }
        //   },
        //   head: headers_3,
        //   body: data_3,
        //   startY: finalY_2 + 40,
        //   margin: {
        //     left: 10,
        //   },
        //   theme: "grid",
        //   tableWidth: 770,
        //   cellWidth: "wrap",
        //   headStyles: {
        //     fillColor: [255, 255, 255],
        //     textColor: [0, 0, 0],
        //     lineColor: [0, 0, 0],
        //   },
        //   tableLineColor: 200,
        //   tableLineWidth: 0,
        //   columnStyles: {
        //     0: {
        //       cellWidth: "auto",
        //       lineColor: "black",
        //       textColor: [0, 0, 0],
        //       halign: "center",
        //     },
        //     1: {
        //       cellWidth: "auto",
        //       lineColor: "black",
        //       textColor: [0, 0, 0],
        //       halign: "center",
        //     },
        //     2: {
        //       cellWidth: "auto",
        //       lineColor: "black",
        //       textColor: [0, 0, 0],
        //       halign: "right",
        //     },
        //     3: {
        //       cellWidth: "auto",
        //       lineColor: "black",
        //       textColor: [0, 0, 0],
        //       halign: "left",
        //     },
        //     4: {
        //       cellWidth: "auto",
        //       lineColor: "black",
        //       textColor: [0, 0, 0],
        //       halign: "center",
        //     },
        //     5: {
        //       cellWidth: "auto",
        //       lineColor: "black",
        //       textColor: [0, 0, 0],
        //       halign: "right",
        //     },
        //     6: {
        //       cellWidth: "auto",
        //       lineColor: "black",
        //       textColor: [0, 0, 0],
        //       halign: "left",
        //     },
        //   },
        //   styles: {
        //     overflow: "linebreak",
        //     cellWidth: "wrap",
        //     fontSize: 10,
        //     lineWidth: 2,
        //     halign: "center",
        //   },
        // });

        // Next Page...

        doc.addPage();
        // let finalY_3 = doc.autoTable.previous.finalY;

        // Here is the Boxes of CASH DEPOSIT / FINAL REMITTANCE

        doc.setFillColor(224, 224, 224);
        doc.setLineWidth(2);
        doc.setDrawColor(0, 0, 0);
        doc.rect(10, 10, 770, 30, "DF");

        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text("CASH DEPOSIT / FINAL REMITTANCE", 405, 27, {
          align: "center",
        });

        // Here is the Data of CASH DEPOSIT / FINAL REMITTANCE

        const headers_4 = [
          [
            "Date",
            "Time",
            "Terminal",
            "Amount",
            "Amount in Words",
            "Cashier's Name",
          ],
        ];

        const data_4 = [];

        if (this.viewData.cash_deposit) {
          this.viewData.cash_deposit.forEach((item) => {
            let theData_4 = [
              this.$dateFormat(item.date, "MM/DD/YYYY"),
              this.$dateFormat(item.date, "hh:mm:ss A"),
              item.terminal ? item.terminal.toUpperCase() : "-",
              "P" + " " + this.numberWithCommas(item.amount),
              this.$amountToWord(item.amount).toUpperCase(),
              item.name ? item.name.toUpperCase() : "-",
            ];
            data_4.push(theData_4);
          });
        }

        doc.autoTable({
          didParseCell: (data) => {
            const col = data.column.index;
            if (
              col === 1 ||
              col === "1" ||
              col === 3 ||
              col === "3" ||
              col === 4 ||
              col === "4"
            ) {
              data.table.styles.headStyles.halign = "left";
            } else if (col === 2 || col === "2") {
              data.table.styles.headStyles.halign = "right";
            } else {
              data.table.styles.headStyles.halign = "center";
            }
          },
          head: headers_4,
          body: data_4,
          startY: 40,
          margin: {
            left: 10,
          },
          theme: "grid",
          tableWidth: 770,
          cellWidth: "wrap",
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
          },
          tableLineColor: 200,
          tableLineWidth: 0,
          columnStyles: {
            0: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "center",
            },
            1: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "center",
            },
            2: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "left",
            },
            3: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            4: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "left",
            },
            5: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "left",
            },
          },
          styles: {
            overflow: "linebreak",
            cellWidth: "wrap",
            fontSize: 10,
            lineWidth: 2,
            halign: "center",
          },
        });

        //
        let finalY_4 = doc.autoTable.previous.finalY;

        // Here is the Boxes of CASH ADVANCE

        doc.setFillColor(224, 224, 224);
        doc.setLineWidth(2);
        doc.setDrawColor(0, 0, 0);
        doc.rect(10, finalY_4 + 10, 770, 30, "DF");

        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text("CASH ADVANCE", 405, finalY_4 + 27, {
          align: "center",
        });

        // Here is the Data of CASH ADVANCE

        const headers_5 = [
          [
            "Date",
            "Time",
            "Terminal",
            "Amount",
            "Amount in Words",
            "Cashier's Name",
          ],
        ];

        const data_5 = [];

        if (this.viewData.cash_advances) {
          if (this.viewData.cash_advances.cash_advances) {
            this.viewData.cash_advances.cash_advances.forEach((item) => {
              let theData_5 = [
                this.$dateFormat(item.date, "MM/DD/YYYY"),
                this.$dateFormat(item.date, "hh:mm:ss A"),
                item.terminal ? item.terminal.toUpperCase() : "-",
                "P" + " " + this.numberWithCommas(item.amount),
                this.$amountToWord(item.amount).toUpperCase(),
                item.name ? item.name.toUpperCase() : "-",
              ];
              data_5.push(theData_5);
            });
          }
        }

        doc.autoTable({
          didParseCell: (data) => {
            const col = data.column.index;
            if (
              col === 1 ||
              col === "1" ||
              col === 3 ||
              col === "3" ||
              col === 4 ||
              col === "4"
            ) {
              data.table.styles.headStyles.halign = "left";
            } else if (col === 2 || col === "2") {
              data.table.styles.headStyles.halign = "right";
            } else {
              data.table.styles.headStyles.halign = "center";
            }
          },
          head: headers_5,
          body: data_5,
          startY: finalY_4 + 40,
          margin: {
            left: 10,
          },
          theme: "grid",
          tableWidth: 770,
          cellWidth: "wrap",
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
          },
          tableLineColor: 200,
          tableLineWidth: 0,
          columnStyles: {
            0: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "center",
            },
            1: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "center",
            },
            2: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "left",
            },
            3: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "right",
            },
            4: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "left",
            },
            5: {
              cellWidth: "auto",
              lineColor: "black",
              textColor: [0, 0, 0],
              halign: "left",
            },
          },
          styles: {
            overflow: "linebreak",
            cellWidth: "wrap",
            fontSize: 10,
            lineWidth: 2,
            halign: "center",
          },
        });
        //

        // Next Page...

        doc.addPage();

        // Box for COLLECTION AND EXPENSES COMPUTATIONS

        doc.setFillColor(224, 224, 224);
        doc.setLineWidth(2);
        doc.setDrawColor(0, 0, 0);
        doc.rect(10, 15, 770, 25, "DF");

        // Text for COLLECTION AND EXPENSES COMPUTATIONS

        doc.setFontType("bold");
        doc.text("COLLECTIONS AND EXPENSES COMPUTATIONS", 410, 30, {
          align: "center",
        });

        // Boxes for COLLECTION AND EXPENSES COMPUTATIONS' DATA
        doc.setFillColor(255, 255, 255);
        doc.setLineWidth(2);
        doc.rect(10, 40, 390, 560, "DF");
        doc.rect(400, 40, 380, 560, "DF");

        // Box for Diesel text

        // doc.setFillColor(255, 255, 255);
        // doc.setLineWidth(2);
        // doc.rect(10, 60, 195, 25, "DF");
        // doc.rect(205, 60, 195, 25, "DF");

        // Diesel text

        // doc.setFontType("bold");
        // doc.text("FUEL LOAD", 90, 75);
        // doc.text("GASMAN", 270, 75);

        // Boxes for Name, Qty., Price, Amount ...

        // let x = 10;
        // let y = 85;
        // let width = 390;

        // doc.setFillColor(255, 255, 255);
        // doc.setLineWidth(2);
        // doc.rect(x, y, width * 0.15, 20, "DF");

        // doc.setFillColor(255, 255, 255);
        // doc.setLineWidth(2);
        // doc.rect(x + width * 0.15, y, width * 0.15, 20, "DF");

        // doc.setFillColor(255, 255, 255);
        // doc.setLineWidth(2);
        // doc.rect(x + width * 0.3, y, width * 0.2, 20, "DF");

        // doc.setFillColor(255, 255, 255);
        // doc.setLineWidth(2);
        // doc.rect(x + width * 0.5, y, width * 0.12, 20, "DF");

        // doc.setFillColor(255, 255, 255);
        // doc.setLineWidth(2);
        // doc.rect(x + width * 0.62, y, width * 0.38, 20, "DF");

        // doc.text("DATE", 40, y + 13, "center");
        // doc.text("TIME", 98, y + 13, "center");
        // doc.text("STATION", 165, y + 13, "center");
        // doc.text("LITERS", 227, y + 13, "center");
        // doc.text("NAME", 323, y + 13, "center");

        this.viewData.diesels.map((item) => {
          y += 20;

          doc.setFillColor(255, 255, 255);
          doc.setLineWidth(2);
          doc.rect(x, y, width * 0.15, 20, "DF");

          doc.setFillColor(255, 255, 255);
          doc.setLineWidth(2);
          doc.rect(x + width * 0.15, y, width * 0.15, 20, "DF");

          doc.setFillColor(255, 255, 255);
          doc.setLineWidth(2);
          doc.rect(x + width * 0.3, y, width * 0.2, 20, "DF");

          doc.setFillColor(255, 255, 255);
          doc.setLineWidth(2);
          doc.rect(x + width * 0.5, y, width * 0.12, 20, "DF");

          doc.setFillColor(255, 255, 255);
          doc.setLineWidth(2);
          doc.rect(x + width * 0.62, y, width * 0.38, 20, "DF");

          doc.text(
            this.$dateFormat(item.date, "MM/DD/YYYY"),
            40,
            y + 13,
            "center"
          );
          doc.text(
            this.$dateFormat(item.date, "hh:mm A"),
            98,
            y + 13,
            "center"
          );

          doc.text(item.station, 165, y + 13, "center");
          doc.text(item.liters.toString(), 227, y + 13, "center");

          doc.text(
            item.name ? item.name.toUpperCase() : "-",
            323,
            y + 13,
            "center"
          );
        });
        let name_Y = 55;
        let line_Y = 55;
        let value_Y = 55;

        if (this.$store.state.company.code === "DLTB") {
          this.viewData.sp_contents.special_contents
            .slice(0, 15)
            .forEach((item) => {
              name_Y += 20;
              line_Y += 20;
              value_Y += 20;

              doc.text(item.name.toUpperCase(), 410, name_Y);
              doc.text("_____________________________________", 550, line_Y);
              doc.text("P" + this.numberWithCommas(item.amount), 750, value_Y, {
                align: "right",
              });
            });
        }
        // Text for Gross Revenue ...
        doc.setFontType("bold");

        doc.text("GROSS REVENUE", 410, line_Y + 35);
        doc.text("LESS: CANCELLED AMOUNT", 410, line_Y + 70);
        doc.text("TOTAL EXPENSES", 410, line_Y + 90);
        doc.text("NET REVENUE", 410, line_Y + 110);
        doc.text("TOTAL PARTIAL", 410, line_Y + 130);
        doc.text("TOTAL CASH ADVANCE", 410, line_Y + 150);
        doc.text("CARD SALES", 410, line_Y + 170);
        doc.text("FINAL CASH", 410, line_Y + 200);
        doc.text("CASH RECEIVED", 410, line_Y + 220);
        doc.text("OVER/(SHORT)", 410, line_Y + 240);
        doc.text("REMARKS", 410, line_Y + 290);
        doc.text("_____________________________________", 550, line_Y + 35);
        doc.text("_____________________________________", 550, line_Y + 70);
        doc.text("_____________________________________", 550, line_Y + 90);
        doc.text("_____________________________________", 550, line_Y + 110);
        doc.text("_____________________________________", 550, line_Y + 130);
        doc.text("_____________________________________", 550, line_Y + 150); //cash advance
        doc.text("_____________________________________", 550, line_Y + 170);
        doc.text("_____________________________________", 550, line_Y + 200);
        doc.text("_____________________________________", 550, line_Y + 220);
        doc.text("_____________________________________", 550, line_Y + 240);
        doc.text(
          "P" + this.numberWithCommas(this.viewData.header.gross_collection),
          750,
          line_Y + 35,
          { align: "right" }
        );
        doc.text(
          "P" + this.numberWithCommas(this.viewData.header.total_cancel_amount),
          750,
          line_Y + 70,
          { align: "right" }
        );
        doc.text(
          "P" + this.numberWithCommas(this.viewData.header.total_expense),
          750,
          line_Y + 90,
          { align: "right" }
        );
        doc.text(
          this.viewData.header.company_code === "DLTB"
            ? "P" +
                this.numberWithCommas(this.viewData.sp_contents.net_remittance)
            : "P" + this.numberWithCommas(this.viewData.header.net_remittance),
          750,
          line_Y + 110,
          { align: "right" }
        );
        doc.text(
          "P" + this.numberWithCommas(this.viewData.header.total_partial),
          750,
          line_Y + 130,
          { align: "right" }
        );
        doc.text(
          "P" +
            this.numberWithCommas(
              this.viewData.cash_advances.total_cash_advance
            ),
          750,
          line_Y + 150,
          { align: "right" }
        );
        doc.text(
          "P" + this.numberWithCommas(this.viewData.tick_issuance.card_sales),
          750,
          line_Y + 170,
          { align: "right" }
        );
        doc.text(
          this.viewData.header.company_code === "DLTB"
            ? "P" + this.numberWithCommas(this.viewData.sp_contents.final_cash)
            : "P" + this.numberWithCommas(this.viewData.header.final_cash),
          750,
          line_Y + 200,
          { align: "right" }
        );
        doc.text(
          "P" + this.numberWithCommas(this.viewData.header.cash_received),
          750,
          line_Y + 220,
          { align: "right" }
        );
        doc.text(
          this.viewData.header.company_code === "DLTB"
            ? "P" + this.numberWithCommas(this.viewData.sp_contents.short_over)
            : "P" + this.numberWithCommas(this.viewData.header.short_over),
          750,
          line_Y + 240,
          { align: "right" }
        );

        if (this.$store.state.company.code === "DLTB") {
          if (this.viewData.header.coding) {
            doc.text(
              "CODING",
              410,
              name_Y + 260
            );
            doc.text("________", 460, line_Y + 260);
            doc.text(this.viewData.header.coding, 490, value_Y + 260, {
              align: "right",
            });
          }
        }
        // Text for Expenses

        let nameY = 210;
        let lineY = 209;
        let valueY = 208;

        if (this.viewData.expenses.length > 15) {
          this.viewData.expenses.slice(0, 15).forEach((item) => {
            nameY += 20;
            lineY += 20;
            valueY += 20;

            doc.text(item.name.toUpperCase(), 30, nameY);
            doc.text("_____________________________________", 180, lineY);
            doc.text("P" + this.numberWithCommas(item.amount), 370, valueY, {
              align: "right",
            });
          });

          // Next Page...

          doc.addPage();

          // Boxes for COLLECTION AND EXPENSES COMPUTATIONS' DATA EXTENSION
          doc.setFillColor(255, 255, 255);
          doc.setLineWidth(2);
          doc.rect(10, 10, 390, 590, "DF");
          doc.rect(400, 10, 380, 590, "DF");

          let nameYNew = 30;
          let lineYNew = 29;
          let valueYNew = 28;

          this.viewData.expenses
            .slice(15, this.viewData.expenses.length)
            .forEach((item) => {
              nameYNew += 20;
              lineYNew += 20;
              valueYNew += 20;

              doc.text(item.name, 30, nameYNew);
              doc.text("_____________________________________", 180, lineYNew);
              doc.text(
                "P" + this.numberWithCommas(item.amount),
                370,
                valueYNew,
                {
                  align: "right",
                }
              );
            });

          // Text for Total Expenses ....

          doc.text("TOTAL EXPENSES", 30, nameYNew + 30);
          doc.text("CASH SALES", 30, nameYNew + 50);
          doc.text("CARD SALES", 30, nameYNew + 70);
          doc.text("PRE-SELL SALES", 30, nameYNew + 90);
          doc.text("_____________________________________", 150, lineYNew + 30);
          doc.text("_____________________________________", 150, lineYNew + 50);
          doc.text("_____________________________________", 150, lineYNew + 70);
          doc.text("_____________________________________", 150, lineYNew + 90);
          doc.text(
            "P" + this.numberWithCommas(this.viewData.header.total_expense),
            350,
            lineYNew + 29,
            { align: "right" }
          );
          doc.text(
            "P" + this.numberWithCommas(this.viewData.tick_issuance.cash_sales),
            350,
            lineYNew + 49,
            { align: "right" }
          );
          doc.text(
            "P" + this.numberWithCommas(this.viewData.tick_issuance.card_sales),
            350,
            lineYNew + 69,
            { align: "right" }
          );
          doc.text(
            "P" +
              this.numberWithCommas(this.viewData.tick_issuance.presell_sales),
            350,
            lineYNew + 69,
            { align: "right" }
          );
        } else {
          this.viewData.expenses.forEach((item) => {
            nameY += 20;
            lineY += 20;
            valueY += 20;

            doc.text(item.name, 30, nameY);
            doc.text("_____________________________________", 180, lineY);
            doc.text("P" + this.numberWithCommas(item.amount), 370, valueY, {
              align: "right",
            });
          });

          // Text for Total Expenses ....

          doc.text("TOTAL EXPENSES", 30, nameY + 30);
          doc.text("CASH SALES", 30, nameY + 50);
          doc.text("CARD SALES", 30, nameY + 70);
          doc.text("PRE-SELL SALES", 30, nameY + 90);
          doc.text("_____________________________________", 150, lineY + 30);
          doc.text("_____________________________________", 150, lineY + 50);
          doc.text("_____________________________________", 150, lineY + 70);
          doc.text("_____________________________________", 150, lineY + 90);
          doc.text(
            "P" + this.numberWithCommas(this.viewData.header.total_expense),
            350,
            lineY + 29,
            { align: "right" }
          );
          doc.text(
            "P" + this.numberWithCommas(this.viewData.tick_issuance.cash_sales),
            350,
            lineY + 49,
            { align: "right" }
          );
          doc.text(
            "P" + this.numberWithCommas(this.viewData.tick_issuance.card_sales),
            350,
            lineY + 69,
            { align: "right" }
          );
          doc.text(
            "P" +
              this.numberWithCommas(this.viewData.tick_issuance.presell_sales),
            350,
            lineY + 89,
            { align: "right" }
          );
        }
      }
      doc.save("EOD " + this.viewData.header.control_no + ".pdf");
    },
    async downloadAbstractPDF(data) {
      const doc = new JsPdf("l", "pt", "letter");

      doc.setFontSize(12);
      // doc.setFontType("bold");
      doc.text(
        this.abstractData.sub_company
          ? this.abstractData.sub_company.toUpperCase()
          : "--",
        390,
        30,
        {
          align: "center",
        }
      );
      doc.setFontSize(14);
      doc.text("ABSTRACT OF DAILY CASH REPORT", 390, 45, {
        align: "center",
      });
      doc.setFontSize(12);
      doc.text(
        this.openDate
          ? this.$dateFormat(this.openDate, "YYYY-MM-DD HH:mm A")
          : "--",
        390,
        60,
        {
          align: "center",
        }
      );

      const headers = [
        [
          "OR No.",
          "Store Name",
          "Trip Date",
          "No. of Trips",
          "KM Run",
          "Driver",
          "Conductor",
          "Gross Income",
          "Partial & Special",
          "DriCon Comm",
          "Toll & Road",
          "DriCon Adv.",
          "Net Cash",
          "Short / Over",
        ],
      ];

      const body = data.map((item) => {
        return [
          item.or_no ? item.or_no : "--",
          item.vehicle_no,
          item.trip_date
            ? this.$dateFormat(item.trip_date, "YYYY-MM-DD HH:mm A")
            : "--",
          item.no_of_trips ? item.no_of_trips : "--",
          item.km_run ? item.km_run : 0,
          item.driver ? item.driver.toUpperCase() : "--",
          item.conductor ? item.conductor.toUpperCase() : "--",
          item.gross_income ? item.gross_income.toFixed(2) : "--",
          item.partial_special ? item.partial_special.toFixed(2) : "--",
          item.dricon_commission ? item.dricon_commission.toFixed(2) : "--",
          item.toll_road ? item.toll_road.toFixed(2) : "--",
          item.dricon_advances ? item.dricon_advances.toFixed(2) : "--",
          item.net_cash ? item.net_cash.toFixed(2) : "--",
          item.short_over ? item.short_over.toFixed(2) : "--",
        ];
      });

      const footer = [
        [
          "Total",
          this.abstractTotal.count ? this.abstractTotal.count : "--",
          "",
          this.abstractTotal.no_of_trips
            ? this.abstractTotal.no_of_trips
            : "--",
          this.abstractTotal.km_run ? this.abstractTotal.km_run : 0,
          "",
          "",
          this.abstractTotal.gross_income
            ? this.abstractTotal.gross_income.toFixed(2)
            : "--",
          this.abstractTotal.partial_special
            ? this.abstractTotal.partial_special.toFixed(2)
            : "--",
          this.abstractTotal.dricon_commission
            ? this.abstractTotal.dricon_commission.toFixed(2)
            : "--",
          this.abstractTotal.toll_road
            ? this.abstractTotal.toll_road.toFixed(2)
            : "--",
          this.abstractTotal.dricon_advances
            ? this.abstractTotal.dricon_advances.toFixed(2)
            : "--",
          this.abstractTotal.net_cash
            ? this.abstractTotal.net_cash.toFixed(2)
            : "--",
          this.abstractTotal.short_over
            ? this.abstractTotal.short_over.toFixed(2)
            : "--",
        ],
      ];

      doc.autoTable({
        didParseCell: (data) => {
          const col = data.column.index;

          if (
            col === 7 ||
            col === "7" ||
            col === 8 ||
            col === "8" ||
            col === 9 ||
            col === "9" ||
            col === 10 ||
            col === "10" ||
            col === 11 ||
            col === "11" ||
            col === 12 ||
            col === "12" ||
            col === 13 ||
            col === "13"
          ) {
            data.table.head[0].cells[col].styles.halign = "right";
          } else if (
            col === 0 ||
            col === "0" ||
            col === 1 ||
            col === "1" ||
            col === 2 ||
            col === "2"
          ) {
            data.table.head[0].cells[col].styles.halign = "center";
          } else {
            data.table.head[0].cells[col].styles.halign = "left";
          }
        },
        head: headers,
        body: body,
        foot: footer,
        startY: 75,
        margin: {
          left: 5,
        },
        theme: "grid",
        tableWidth: 782,
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
        },
        footStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          halign: "right",
        },
        showFoot: "lastPage",
        tableLineColor: 200,
        tableLineWidth: 0,
        columnStyles: {
          0: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "center",
          },
          1: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "center",
          },
          2: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "center",
          },
          3: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          4: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          5: {
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          6: {
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          7: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          8: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          9: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          10: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          11: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          12: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          13: {
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
        },
        styles: {
          overflow: "linebreak",
          lineColor: "black",
          textColor: [0, 0, 0],
          fontSize: 7.25,
          lineWidth: 1,
        },
      });

      doc.save(
        (this.abstractData.sub_company
          ? this.abstractData.sub_company.toUpperCase()
          : "--") +
          " " +
          "DAILY ABSTRACT REPORT.pdf"
      );
    },
    saveUpDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveAddDialog() {
      if (this.$refs.form.validate()) {
        this.openConfirmDialog = true;
      }
    },
    async saveConfirmedAddDialog() {
      this.confirmLoading = true;

      const employees = this.selected.map((employee) => {
        return {
          id: employee.id,
          position: employee.position,
          web_position: employee.web_position,
        };
      });

      const body = {
        employees: employees,
        project_id: this.$store.state.project.id,
        sub_company_id: this.$store.state.subcompany.id,
      };
      console.log(body);
      try {
        const response = await Services.assignEmployees(body);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeAddDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Employee(s) has been added",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveEditDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData,
        body = {
          id: data.id,
          first_name: data.first_name,
          middle_name: data.middle_name,
          last_name: data.last_name,
          email: data.email,
          gender: data.gender,
          nationality: data.nationality,
          birth_date: data.birth_date,
          civil_status: data.civil_status,
          unit_no: data.unit_no,
          house_no: data.house_no,
          street: data.street,
          subdivision: data.subdivision,
          barangay: data.barangay,
          city: data.city,
          province: data.province,
          zip_code: data.zip_code,
          issued_company_id: data.issued_company_id,
          access_card_id: data.access_card_id,
        };
      console.log(body);
      try {
        const response = await Services.editEmployee(body);
        console.log(response.status);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Employee has been updated!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteEmployee(this.viewData.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Employee has been deleted!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },
    async closeDialog() {
      if (this.dialogLoading === false) {
        // this.$refs.detailsRef.clear();
      }

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
      this.dialogStatusAbstract = false;

      this.abstractData = {};
      this.abstractRemittance = [];
      this.abstractTotal = {};

      // this.viewData = {};
    },
    closeAddDialog() {
      this.selected = [];
      this.closeConfirmDialog();
      this.dialogType = "";
      this.addDialog = false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.employeeItems.slice();
    },
    async openSubscribeDialog(data) {
      this.dialogLoading = true;
      this.dialogType = "assign";
      this.subscribeDialog = true;
      this.viewData = data;

      this.viewData = await this.setData(data.id);
      console.log(this.viewData);
      this.assignedItems = await this.viewData.projects;
      await this.getProjects();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async closeSubscribeDialog() {
      this.selected = [];
      this.viewData = {};
      this.closeConfirmDialog();
      this.dialogType = "";
      this.subscribeDialog = false;
    },
    saveSubscribeDialog() {
      this.openConfirmDialog = true;
    },
    notSubscribe(data) {
      for (var e = 0; e < this.assignedItems.length; e++) {
        if (this.assignedItems[e].id === data.id) {
          return false;
        }
      }
      return true;
    },
    showSubcribe(data) {
      for (var e = 0; e < this.selected.length; e++) {
        if (this.selected[e].id === data.id) {
          return false;
        }
      }
      return true;
    },
    subscribeToProject(data) {
      this.selected.push(data);
      console.log(this.selected);
    },
    unsubscribeToProject(data) {
      for (var e = 0; e < this.selected.length; e++) {
        if (this.selected[e].id === data.id) {
          this.selected.splice(e, 1);
        }
      }
      console.log(this.selected);
    },
    async saveConfirmedSubscribeDialog() {
      this.confirmLoading = true;

      const projects = this.selected.map((project) => {
        return {
          id: project.id,
          position: project.SubCompanyProject.position,
          web_position: project.SubCompanyProject.web_position,
        };
      });
      const body = {
        projects: projects,
        employee_id: this.viewData.id,
      };
      console.log(body);
      try {
        const response = await Services.assignEmployeetoProject(body);
        console.log(response.status);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeSubscribeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Project/s has been assigned to Employee!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },
    refreshTable() {
      this.$refs.searchRef.clear();
      this.filterPosition = null;
      this.getData();
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterCompanies();
      await this.setFilterSubCompanies();
    },
    async setFilterCompanies() {
      this.$store.state.companies.map((item) => {
        let body = {
          text: item.name.toUpperCase(),
          value: item.id,
        };
        this.filterCompanies.push(body);
      });
    },
    async setFilterSubCompanies() {
      this.$store.state.sub_companies.map((item) => {
        let body = {
          text: item.name.toUpperCase(),
          value: item.id,
        };
        this.filterSubCompanies.push(body);
      });
    },
    // async setFilterPosition() {
    //   const items = (await Services.getEmployees({
    //     limit: this.items.count,
    //     company_id: this.$store.state.company.id,
    //     sub_company_id: this.$store.state.subcompany.id,
    //     project_id: this.$store.state.project.id
    //   })).data.data;

    //   let toPush = [];

    //   items.forEach(item1 => {
    //     item1.projects.forEach(item2 => {
    //       toPush.push(item2.ProjectEmployee.position);
    //     });
    //   });

    //   let unique = [...new Set(toPush)];

    //   unique.forEach(position => {
    //     let body = {
    //       text: position.toUpperCase(),
    //       value: position.toUpperCase()
    //     };
    //     this.filterPositions.push(body);
    //   });
    // }
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>
